// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47053fcb","239":"e82bac19","732":"dfba15e9"}[chunkId] + ".chunk.js";
};